<!-- src/App.svelte -->
<script lang="ts">
  window["modern_mode"] = true;
  import { Router } from "@roxi/routify";
  import { routes } from "../generated_routes/routes.js";
  import { afterPageLoad } from "@roxi/routify";
  import GitRevisionCheck from "@shared/services/git_revision_check_modern";

  $afterPageLoad(page => {
    GitRevisionCheck.checkAndDoHardRefresh();
    return true;
  });

  function createSearchParams(params) {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, values]) => {
      if (Array.isArray(values)) {
        values.forEach(value => {
          searchParams.append(key, value);
        });
      } else {
        searchParams.append(key, values as string);
      }
    });
    return searchParams;
  }

  function getAllSearchParams(search) {
    let s = new URLSearchParams(search);
    let res = {};
    for (const key of s.keys()) {
      res[key] = s.getAll(key);
      if (res[key].length === 1) {
        res[key] = res[key][0];
      }
    }
    return res;
  }

  const config = {
    queryHandler: {
      parse: function (search) {
        return getAllSearchParams(search);
      },
      stringify: function (params) {
        return "?" + createSearchParams(params).toString();
      },
    },
    urlTransform: {
      apply: x => x,
      remove: x => x,
    },
    useHash: false,
  };
</script>

<Router {routes} {config} />
